import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>404 - Page Not Found</h1>
      <p style={styles.text}>Sorry, the page you are looking for does not exist.</p>
      <Link to="/" style={styles.link}>Go to Home</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '50px',
  },
  header: {
    fontSize: '48px',
    margin: '20px 0',
  },
  text: {
    fontSize: '24px',
  },
  link: {
    fontSize: '20px',
    color: '#007bff',
    textDecoration: 'none',
  },
};

export default PageNotFound;
